export const animateScroll = (target, opts = {}) => {
  const offset = opts.offset || 0;
  let top;
  if (typeof target === "number") {
    top = target;
  } else if (target && target.getBoundingClientRect) {
    top = target.getBoundingClientRect().top + window.pageYOffset;
  } else {
    return;
  }
  window.scrollTo({
    top: Math.max(0, top - offset),
    behavior: "smooth",
  });
};

const scroll = { animateScroll };

export default scroll;
